import { useAuth } from "oidc-react";
import { useCallback } from "react";
import { useNavigate } from "react-router";
import { request } from "../utils/request";

const dsbLayerUrl = import.meta.env.VITE_DSBLAYERURL;

/**
 * Fetcher for the Hector One API. Unlike `useFetcher` it does not prefix the
 * customer's seoTitle: Hector One routes live at `/hectorone/{seoTitle}/...`,
 * not at `/{seoTitle}/...`, so the caller passes the full path.
 */
export default function useHectorOneFetcher() {
  const navigate = useNavigate();
  const auth = useAuth();

  return useCallback(
    function <T>(url: string): Promise<T> {
      return request<T>(`${dsbLayerUrl}/hectorone${url}`, {
        token: auth?.userData?.access_token,
        onUnauthorized: () => navigate("/unauthorized"),
      });
    },
    [navigate, auth]
  );
}
